module.exports = __webpack_public_path__ + "media/images/icons/arrow_down-617e7eed03417db264894b86c30bda92.svg";